export class AuthHttpError extends Error {
  constructor(
    readonly status: number,
    readonly statusText: string,
    readonly url: string,
  ) {
    super(`${status} ${statusText}`);
    this.name = "AuthHttpError";
  }
}
